import { render, staticRenderFns } from "./MpRecipeCard.vue?vue&type=template&id=53d71b0a&scoped=true&lang=pug&"
import script from "./MpRecipeCard.vue?vue&type=script&lang=js&"
export * from "./MpRecipeCard.vue?vue&type=script&lang=js&"
import style0 from "./MpRecipeCard.vue?vue&type=style&index=0&id=53d71b0a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d71b0a",
  null
  
)

export default component.exports